import React from 'react';
import { GlobeIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { copy } from '../data/copy';
import type { Lang } from '../types/i18n';
const options: {
  value: Lang;
  label: string;
}[] = [{
  value: 'en',
  label: 'English'
}, {
  value: 'es',
  label: 'Español'
}];
interface LanguageSwitcherProps {
  tone?: 'dark' | 'light';
  compact?: boolean;
}
export function LanguageSwitcher({
  tone = 'dark',
  compact = false
}: LanguageSwitcherProps) {
  const {
    lang,
    setLang,
    t
  } = useLanguage();
  const base = tone === 'dark' ? 'border-navy-800 bg-navy-900' : 'border-navy-200 bg-white';
  const idle = tone === 'dark' ? 'text-navy-300 hover:text-white' : 'text-navy-500 hover:text-navy-900';
  const active = tone === 'dark' ? 'bg-gold-500 text-navy-950' : 'bg-navy-900 text-white';
  return <div className={`inline-flex items-center gap-1 rounded-md border p-0.5 ${base}`} role="group" aria-label={t(copy.nav.language)} data-id="element-291" data-mp="i6cddikyx1tq">
      {!compact && <GlobeIcon width={15} height={15} aria-hidden="true" className={`ml-1.5 ${tone === 'dark' ? 'text-navy-400' : 'text-navy-400'}`} data-id="element-292" data-mp="2cknoudswyt46" />}
      {options.map(option => <button key={option.value} type="button" onClick={() => setLang(option.value)} aria-pressed={lang === option.value} className={`rounded px-2.5 py-1 text-xs font-bold transition-colors duration-150 ease-smooth ${lang === option.value ? active : idle}`} data-id="element-293" data-mp="1yn8v4wvmnz6e">
          {compact ? option.value.toUpperCase() : option.label}
        </button>)}
    </div>;
}